'use client';
import { Box, Container, Heading, Text } from '@chakra-ui/react';
import { getImageProps } from 'next/image';

import LinkCustom from '@/app/_components/link/LinkCustom';
import { getImageLink } from '@/services/link.service';
import { CallToAction } from '@/types/home/home.types';
import { directusImageLoader } from '@/utils/loaders';

import styles from './HeroBanner.module.scss';

export const HeroBanner = ({
  title,
  description,
  image = '',
  banner_call_to_actions,
  isCtaHidden = false,
}: {
  title: string;
  description: string;
  image: string;
  banner_call_to_actions: CallToAction[];
  isCtaHidden?: boolean;
}) => {
  const imageKeys = {
    desktopKey: 'image-1440-680',
    mobileKey: 'image-430-305',
  };
  const common = {
    alt: 'Hero',
    width: 1280,
    height: 681,
    loader: directusImageLoader,
  };
  const {
    props: { srcSet: mobile },
  } = getImageProps({
    ...common,
    src: `${getImageLink(image)}?key=${imageKeys.mobileKey}`,
  });
  const {
    props: { srcSet: desktop, ...rest },
  } = getImageProps({
    ...common,
    src: `${getImageLink(image)}?key=${imageKeys.desktopKey}`,
  });

  return (
    <div>
      <Box
        className={styles.headerWrapper}
        display={'flex'}
        flexDirection={{ base: 'column', lg: 'row' }}
        alignItems={'flex-end'}
        justifyContent={'center'}
        height={{ base: 'auto', lg: '558px' }}
        paddingBottom={{ base: '56px', lg: '0' }}
      >
        <Container
          maxW={'750'}
          width={'100%'}
          alignContent={'center'}
          zIndex={1}
          paddingX={{ base: 6 }}
          paddingY={'56px'}
          className={styles.bannerContentSection}
        >
          <Box className={styles.headingElement} textAlign={'center'}>
            <Heading
              as="h1"
              className="titleLg"
              color={'white'}
              marginBottom={{ base: 4 }}
            >
              {title}
            </Heading>
            <Text className={styles.titleText} color={'white'} mb={8}>
              {description}
            </Text>
            {!isCtaHidden &&
              banner_call_to_actions?.map((action, i) => (
                <LinkCustom
                  key={i}
                  aria-label="View All"
                  href={action?.url}
                  target={
                    action?.url.indexOf('http') === 0 ? '_blank' : undefined
                  }
                  rel={
                    action?.url?.indexOf('http') === 0
                      ? 'noreferrer noopener'
                      : ''
                  }
                  className="btnOutlineWhite"
                >
                  {action?.text}
                </LinkCustom>
              ))}
          </Box>
        </Container>
        <picture className={styles.heroImage}>
          <source media="(max-width: 575px)" srcSet={mobile} />
          <source media="(min-width: 576px)" srcSet={desktop} />
          <img
            {...rest}
            alt="after-sales background image"
            loading="eager"
            fetchPriority="high"
          />
        </picture>
      </Box>
    </div>
  );
};
